module.exports = __webpack_public_path__ + "img/wallet-ico.18f902c7.svg";